import React, { useContext } from 'react';
import Chart from 'react-google-charts';

import { Card, CardHeader } from '@material-ui/core';
import DashboardContext from 'src/pages/Private/Dashboard/context';
import { defaultChartOptions } from 'src/utils/charts';

const CategorySolicitationsChart: React.FC = () => {
  const {
    chartsInfo: { categoriesSolicitations },
  } = useContext(DashboardContext);

  return (
    <Card style={{ height: '100%' }}>
      <CardHeader
        title="IFEPAF + IFBOLSAS"
        subheader="4 CATEGORIAS MAIS UTILIZADAS"
      />

      <Chart
        chartType="ColumnChart"
        data={categoriesSolicitations}
        options={defaultChartOptions}
      />
    </Card>
  );
};

export default CategorySolicitationsChart;
